var _line, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.434057,
    x2: 12.9016,
    y2: -0.434057,
    transform: "matrix(-1 0 0 1 14.1719 7.3125)",
    stroke: "#2CD9B8",
    strokeWidth: 0.868114
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.07422 0.972656C5.61989 4.50693 4.03198 5.50747 1.00289 7.04398",
    stroke: "#2CD9B8",
    strokeWidth: 0.868114
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07422 13.0312C5.61989 9.49697 4.03198 8.49643 1.00289 6.95992",
    stroke: "#2CD9B8",
    strokeWidth: 0.868114
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreArrow);
export default __webpack_public_path__ + "static/media/preArrow.d91c8acdf658463dcff5a471019f977b.svg";
export { ForwardRef as ReactComponent };